import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 36 36"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "var(--stroke-0, white)",
      "stroke-opacity": ".2",
      d: "M18 35.5c9.665 0 17.5-7.835 17.5-17.5S27.665.5 18 .5.5 8.335.5 18 8.335 35.5 18 35.5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--fill-0, white)",
      "fill-opacity": ".5",
      d: "M22.5 10.615v2.539h-1.454q-.795 0-1.074.346-.278.346-.278 1.038v1.818h2.713l-.36 2.846h-2.353V26.5h-2.833v-7.298H14.5v-2.846h2.36V14.26q0-1.789.964-2.774.963-.986 2.565-.986 1.36 0 2.111.115"
    }, null, -1)
  ]))]))
}
export default { render: render }